import { url } from "inspector";
import { Endpoint } from "../config";

export type LienEndpointType =
  | "getLien"
  | "createLien"
  | "getLienById"
  | "createLienRecord"
  | "getLienSummaryById"
  | "downloadLienSummary"
  | "getLienSummaryAuditLogs"
  | "downloadLienSummaryAuditLogs"
  | "generateLienWaiver"
  | "updateLienSummary"
  | "updateLienWaiver"
  | "getLienWaiverAuditLogs"
  | "downloadLienWaiverAuditLogs"
  | "downloadLienWaiver"
  | "getLienWaiver"
  | "updateLienWaiverBySummaryId"
  | "updateLien"
  | "updateLienStatus"
  | "getLienByStatusToDo"
  | "getLienByStatusToReview"
  | "getLienByStatusToCorrect"
  | "getLienByStatusApproved"
  | "getLienByStatusWaiverAndPayoutRequest"
  | "getLienByStatusSuccessfullyClosed"
  | "getLienByStatusDealCancelled"
  | "getLienTodo"
  | "getLienReview"
  | "editLienData"
  | "editOpportunityData"
  | "uploadPPSALien"
  | "createBulkOpportunity"
  | "removeLienRecord"
  | "getLienToCorrect"
  | "getLienToApprove"
  | "getLienToPayout"
  | "getLienToCancel"
  | "getLienToClosed"
  | "deleteS3Records"
  | "updateOpportunityStatus"
  | "getAuditData"
  | "getPayoutSummaryById"
  | "getandUpdateWaiverDataById"
  | "getOpportunityData"
  | "retryLienProcess"
  | "updateLienData"
  | "updateOpportunityData"
  | "getOpportunityById"
  | "allDocuments"
  | "updateDocuments"
  | "getCompanyDetails"
  | "updateTileDetails"
  | "getCompanyLoanTypes"
  | "editLoanTypes"
  | "getAllDebtors"
  | "debtorCreate"
  | "debtorDelete"
  | "debtorUpdate"
  | "allNamesoftheHistoricalReport"
  | "timezoneList"
  | "getAllJobs"
  | "updateJobStatus"
  | "opportunityUpload"
  | "editOrReviewOpportunity"
  | "createOpportunity"
  | "llmtokenusage"
  | "getExpiryReport"
  | "updateExpiryReportDate";

export const lienEndpoints: Record<LienEndpointType, Endpoint> = {
  getLien: {
    url: "tenant-lien/",
  },
  getLienTodo: {
    url: "dashboard_TODO_tile/?company_name=[company_name]",
  },
  getLienReview: {
    url: "dashboard_review_tile/?company_name=[company_name]",
  },
  getLienToCorrect: {
    url: "dashboard_correct_tile/?company_name=[company_name]",
  },
  getLienToApprove: {
    url: "dashboard_approved_tile/?company_name=[company_name]",
  },
  getLienToPayout: {
    url: "dashboard_waiver_payout_request_tile/?company_name=[company_name]",
  },
  getLienToCancel: {
    url: "dashboard_cancelled_tile/?company_name=[company_name]",
  },
  getLienToClosed: {
    url: "dashboard_closed_tile/?company_name=[company_name]",
  },
  createLien: {
    url: "tenant-lien/",
  },
  updateLien: {
    url: "tenant-lien/[id]/",
  },
  getLienById: {
    url: "tenant-lien/[id]/",
  },
  createLienRecord: {
    url: "tenant-lien/extract-from-document/?stream=true",
  },
  removeLienRecord: {
    url: "tenant-lien/extract-from-document/",
  },
  getLienSummaryById: {
    url: "tenant-lien-summary/get-summary/?opportunity_id=[opportunity_id]",
  },
  downloadLienSummary: {
    url: "tenant-lien-summary/[id]/download/",
  },
  getLienSummaryAuditLogs: {
    url: "tenant-lien-summary/[id]/audit-logs/",
  },
  downloadLienSummaryAuditLogs: {
    url: "tenant-lien-summary/[id]/download-audit-logs/",
  },
  generateLienWaiver: {
    url: "tenant-lien-summary/[id]/generate-waiver/",
  },
  updateLienSummary: {
    url: "lien-summary-edit/[id]/",
  },
  updateLienWaiver: {
    url: "tenant-lien-summary/[id]/waiver/",
  },
  getLienWaiverAuditLogs: {
    url: "tenant-lien-waiver/[id]/audit-logs/",
  },
  downloadLienWaiverAuditLogs: {
    url: "tenant-lien-waiver/[id]/download-audit-logs/",
  },
  downloadLienWaiver: {
    url: "tenant-lien-waiver/[id]/download/",
  },
  getLienWaiver: {
    url: "tenant-lien-waiver/[id]/",
  },
  updateLienWaiverBySummaryId: {
    url: "tenant-lien-waiver/[id]/",
  },
  updateLienStatus: {
    url: "tenant-lien/status-update/[id]/",
  },
  getLienByStatusToDo: {
    url: "tenant-lien/status/to-do/",
  },
  getLienByStatusToReview: {
    url: "tenant-lien/status/to-review/",
  },
  getLienByStatusToCorrect: {
    url: "tenant-lien/status/to-correct/",
  },
  getLienByStatusApproved: {
    url: "tenant-lien/status/approved/",
  },
  getLienByStatusWaiverAndPayoutRequest: {
    url: "tenant-lien/status/waiver-and-payout-request/",
  },
  getLienByStatusSuccessfullyClosed: {
    url: "tenant-lien/status/successfully-closed/",
  },
  getLienByStatusDealCancelled: {
    url: "tenant-lien/status/deal-cancelled/",
  },
  editLienData: {
    url: "lien-vin-edit/[id]/",
  },
  updateLienData: {
    url: "edit-lien/[id]/",
  },
  editOpportunityData: {
    url: "edit-opportunity/[id]/",
  },
  uploadPPSALien: {
    url: "[country]/manual_document/[name]",
  },
  createBulkOpportunity: {
    url: "create-bulk-opportunity/",
  },
  deleteS3Records: {
    url: "s3/delete-s3/",
  },
  updateOpportunityStatus: {
    url: "update_opportunity_status/[id]/",
  },
  getAuditData: {
    url: "get_audit_logs/?opportunityId=[opportunity_id]",
  },
  getPayoutSummaryById: {
    url: "payout/[opportunity_id]/data?payout_id=[payoutId]",
  },
  getandUpdateWaiverDataById: {
    url: "waiver/[id]/data?waiver_id=[waiverId]",
  },
  getOpportunityData: {
    url: "opportunity/[oppId]/",
  },
  retryLienProcess: {
    url: "retry-opportunity/[opportunityId]/",
  },
  updateOpportunityData: {
    url: "edit_debtors/[opportunityId]/",
  },
  getOpportunityById: {
    url: "opportunity/[id]/",
  },
  allDocuments: {
    url: "all-documents/?company_name=[company_name]",
  },
  updateDocuments: {
    url: "document-details/[id]/?company_name=[company_name]",
  },
  getCompanyDetails: {
    url: "company-details/[company_name]/",
  },
  updateTileDetails: {
    url: "tile-details/[tileId]/?company_name=[company_name]",
  },
  getCompanyLoanTypes: {
    url: "all-loan-types/?company_name=[company_name]",
  },
  editLoanTypes: {
    url: "edit_loan_type/[opportunityId]/",
  },
  getAllDebtors: {
    url: "all-debtors/?company_name=[company_name]",
  },
  debtorCreate: {
    url: "debtor-details/?company_name=[company_name]",
  },
  debtorDelete: {
    url: "debtor-details/[debtorId]/?company_name=[company_name]",
  },
  debtorUpdate: {
    url: "debtor-details/[debtorId]/?company_name=[company_name]",
  },
  allNamesoftheHistoricalReport: {
    url: "all-names-of-projects/?company_name=[company_name]",
  },
  timezoneList: {
    url: "all-timezones/",
  },
  getAllJobs: {
    url: "all-jobs/?company_name=[company_name]",
  },
  updateJobStatus: {
    url: "all-jobs/update-job/?company_name=[company_name]",
  },
  opportunityUpload: {
    url: "opportunity-doc-upload/?company_name=[company_name]",
  },
  editOrReviewOpportunity: {
    url: "edit-review-opportunity/[id]/?company_name=[company_name]",
  },
  createOpportunity: {
    url: "edit-review-opportunity/?company_name=[company_name]",
  },
  llmtokenusage: {
    url: "vertex-ai-usage/",
  },
  getExpiryReport: {
    url: "expiry-date-report/?company_name=[company_name]",
  },
  updateExpiryReportDate: {
    url: "expiry-date-report/[lien_id]/?company_name=[company_name]",
  },
};
